<template>
<div>
    <div class="container-fluid">
        <div>
            <b-card border-variant="secondary" header-text-variant="black" align="center">
                <div slot="header">
                    <!-- <h3>Pr&oacute;ximamente... <i class="far fa-smile-beam"></i> <i class="fas fa-laptop"></i></h3> -->
                    <h2>Kardex</h2>   
                </div>
                <div>
                    <b-row>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="6" >   
                            <b-row>
                                <b-col cols="12" sm="12" md="12" lg="12" xl="12" >
                                    <b-form inline>
                                    Desde: 
                                        <datepicker  v-model="f1" 
                                        :format="customFormatter" 
                                        :bootstrap-styling="true"
                                        :placeholder="currentdate"
                                        :language="es" 
                                        class="input-placedark input-dark ml-2 mr-2">
                                        </datepicker> 
                                    Hasta:
                                        <datepicker v-model="f2" 
                                        :format="customFormatter" 
                                        :bootstrap-styling="true"
                                        :placeholder="currentdate" 
                                        :language="es"
                                        class="input-placedark input-dark ml-2 mr-2">
                                        </datepicker> 
                                        <b-button style="background-color:#DBF3E5;border-color:#DBF3E5" @click="ListadoKardex()" title="Buscar por fecha">
                                            <i class="fas fa-search" ></i>
                                        </b-button>              
                                    </b-form>
                                </b-col>
                            </b-row>
                        </b-col>                 
                       <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                            <b-row>
                                <b-col cols="12" sm="12" md="12" lg="12" xl="7"><b-form-input v-model="descriProducto" placeholder="Nombre producto"></b-form-input></b-col>
                                          
                                <b-col cols="12" sm="12" md="12" lg="12" xl="2"><b-button  style="background-color:#DBF3E5;border-color:#DBF3E5" @click="ProductSearch()" title="Buscar producto">Buscar</b-button></b-col>
                                <!-- <b-button style="background-color:#DBF3E5;border-color:#DBF3E5" @click="InitDate()" title="Actualizar"><i class="fas fa-redo-alt"></i></b-button> -->
                                <b-col cols="12" sm="12" md="12" lg="12" xl="1"><b-button  variant="warning" @click="exportarkardex()">Exportar</b-button></b-col>
                            </b-row>
                           
                       </b-col>
                    </b-row>
                </div>
                <div class="contenedor mt-5">
                        <div v-if="cargandoLista" align="center">
                          <h3>Cargando<i class="fa fa-spin fa-spinner"></i></h3>
                        </div>
                    <div v-else>
                    <b-table 
                    head-variant="light" 
                    responsive 
                    small 
                    :items="mercaderia" 
                    :fields="listado_kardex"
                    :outlined="outlined">
                    <template slot="producto" slot-scope="row">
                        <template v-if="row.item && row.item.product[0]">
                            {{row.item.product[0].descripcion}}
                        </template>
                        <template v-else>
                           <template>Producto no encontrado</template>
                        </template>
                    </template>
                    <template slot="codigo" slot-scope="row">
                        <template v-if="row.item && row.item.product[0]">
                            {{row.item.product[0].codigo}}
                        </template>
                        <template v-else>
                           <template style="color:red">-</template>
                        </template>
                    </template>
                    <template slot="tipoMovim" slot-scope="row">
                        <template v-if="row.item.descripcionMovimiento == 'Venta con Boleta' || row.item.descripcionMovimiento == 'Venta con Factura'">
                           <i style="color:red" class="fas fa-arrow-down"></i>
                        </template>
                    </template>
                    </b-table>
                    </div>
                    <div class="float-right">
                        <b-pagination
                            size="sm"
                            :total-rows="total"
                            v-model="currentPage"
                            @input="ListadoKardex"
                            :per-page="limit"
                        ></b-pagination>
                    </div>
                </div><br> 
                <hr>
                <h2 class="pt-2" style="background-color:#f0f3f5;height:50px">Kardex por Producto</h2> 
                <b-row>
                    <b-col cols="12" sm="2"	md="2"	lg="3"	xl="6">   
                            <b-form inline>
                            Desde: 
                                <datepicker  v-model="fItem1" 
                                :format="customFormatter" 
                                :bootstrap-styling="true"
                                :placeholder="currentdate"
                                :language="es" 
                                class="input-placedark input-dark ml-2 mr-2">
                                </datepicker> 
                            Hasta:
                                <datepicker v-model="fItem2" 
                                :format="customFormatter" 
                                :bootstrap-styling="true"
                                :placeholder="currentdate" 
                                :language="es"
                                class="input-placedark input-dark ml-2 mr-2">
                                </datepicker>            
                            </b-form>
                    </b-col>
                    <b-col ols="12" sm="2"	md="2"	lg="3"	xl="2">
                        <b-form-select
                        class="input-placedark input-dark"
                        v-model="filtroitem"
                        :options="options"
                        ></b-form-select>
                    </b-col>
                    <b-col ols="12" sm="2"	md="2"	lg="3"	xl="3">
                        <template v-if="cambiofiltro">
                            <b-form-input v-model="nameitem" @input="descriptionitem()" placeholder="Ingresar Descripción"></b-form-input>    
                                <b-list-group v-if="listades" class="searcher-field">
                                <template v-for="(item, index) in listaDescription">
                                <b-list-group-item
                                        :key="index"
                                        @click="obteneritem(item)"
                                        class="searcher-result"
                                >{{item.codigo + ' - ' + item.descripcion + ' --- Precio: ' + item.precioUnitario}}</b-list-group-item>
                                </template>
                                </b-list-group>
                        </template>
                        <template v-else>
                            <b-form-input v-model="coditem" placeholder="Ingresar Código"></b-form-input>
                        </template>
                    </b-col>
                    <b-col ols="12" sm="2"	md="2"	lg="3"	xl="1">
                        <template v-if="cambiofiltro">
                            <b-button variant="primary" :disabled="nombreitem" @click="kardexitem()">Buscar</b-button> 
                        </template>
                        <template v-else>
                            <b-button variant="primary" :disabled="codigoitem" @click="kardexitem()">Buscar</b-button>
                        </template> 
                    </b-col> 
                </b-row>
                <b-row class="mt-3">
                    <b-col cols="3"></b-col>
                    <b-col>
                    <template v-if="infoitem !=''">
                    <div  style="float:left;width:50%" >
                        <b-form inline>    
                            <h3>Producto:</h3><h4 style="color:blue" v-if="infoitem !=''" variant="success">{{infoitem[0].product[0].descripcion}}</h4> 
                        </b-form>
                    </div>
                    <div  style="float:left;width:50%" >
                        <b-form inline>    
                            <h3> Total Stock:</h3><h4 style="color:blue" v-if="infoitem !=''" variant="success">{{infoitem[0].product[0].stock}}</h4>
                        </b-form>                 
                    </div>
                    </template>
                    <template v-else>
                        <div style="float:left;width:50%" >
                            <b-form inline>
                                <h3> Producto:</h3><h4 style="color:green" v-if="infoitemsalidas !=''" variant="success">{{infoitemsalidas[0].product[0].descripcion}}</h4>
                            </b-form>
                        </div>
                        <div style="float:left;width:50%" >
                            <b-form inline>
                                <h3>Stock:</h3><h4 style="color:green" v-if="infoitemsalidas !=''" variant="success">{{infoitemsalidas[0].product[0].stock}}</h4>
                            </b-form>
                        </div>
                    </template>
                    </b-col>
                    <b-col cols="1"></b-col>
                </b-row>
                <hr>
                <b-row class="mt-4">
                    <b-col cols="6">   
                        <div style="float:left">
                            <h4 style="color:green">INGRESOS</h4>
                        </div>
                        <b-table 
                            head-variant="light" 
                            bordered
                            responsive
                            small
                            sticky-header
                            hover
                            :items="infoitem" 
                            :fields="fields_infoitem">
                            <template slot="stock" slot-scope="row">
                                {{row.item.product[0].stock}}
                            </template>
                        </b-table>
                        <div class="col-md-6">
                            <p>Mostrando del {{desde2}} al {{hasta2}} de un total de {{total2}} registros</p>
                        </div>
                        <div class="float-right">
                        <b-pagination
                            size="sm"
                            :total-rows="total2"
                            v-model="currentPage2"
                            @input="kardexitem"
                            :per-page="limit2"
                        ></b-pagination>
                    </div>
                    </b-col>
                    <b-col cols="6">
                        <div style="float:left">
                            <h4 style="color:red">SALIDAS</h4>
                        </div>
                        <b-table
                            head-variant="light"
                            bordered
                            hover 
                            small
                            responsive
                            sticky-header
                            :items="infoitemsalidas" 
                            :fields="fields_infoitem">
                        </b-table>
                         <div class="col-md-6">
                            <p>Mostrando del {{desde3}} al {{hasta3}} de un total de {{total3}} registros</p>
                        </div>
                        <div class="float-right">
                        <b-pagination
                            size="sm"
                            :total-rows="total3"
                            v-model="currentPage3"
                            @input="kardexitemsalidas"
                            :per-page="limit3"
                        ></b-pagination>
                        </div>
                    </b-col>
                </b-row> 
                <vue-snotify></vue-snotify>          
            </b-card>
        </div>
    </div>
</div>   
</template>
<script>
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import { AlertPlugin } from 'bootstrap-vue'
import download from 'downloadjs'
export default {
name:'Kardex',
   components:{
        Datepicker,
    },
    data:()=>{
        return{
            mercaderia:[],
            listado_kardex:[
                {key:"idEmisor", label:"Emisor", sorteable: true},
                // {key:"tipoComprobante", label:"Tipo Comprobante", sorteable: true},
                {key:"serie", label:"Serie", sorteable: true},
                {key:"numero", label:"Número", sorteable: true},
                {key:"fechaMovimiento", label:"Fecha", sorteable: true},
                {key:"codigo", label:"Codigo", sorteable: true},
                {key:"producto", label:"Descripcion", sorteable: true},
                {key:"cantidad", label:"Cantidad", sorteable: true},
                {key:"precioVentaUnitario", label:"Precio Venta Uni.", sorteable: true},
                {key:"precioVentatotal", label:"Precio Total", sorteable: true},
                {key:"descripcionMovimiento", label:"Accion", sorteable: true},
                {key:"tipoMovim", label:"", sorteable: true}
            ],
            order:'desc',
            limit:'20',
            currentPage: 1,
            total: 0.0,
            desde: 0.0,
            hasta: 0.0,

            order2:'desc',
            limit2:'15',
            currentPage2: 1,
            total2: 0.0,
            desde2: 0.0,
            hasta2: 0.0,

            order3:'desc',
            limit3:'15',
            currentPage3: 1,
            total3: 0.0,
            desde3: 0.0,
            hasta3: 0.0,
            

            f1:'',
            f2:'',
            currentdate:'',
            es: es,
            cargandoLista: false,
            descriProducto:'',
            outlined: true,
            fItem1:'',
            fItem2:'',
            infoitem:[],
            fields_infoitem:[
                {key:'descripcionMovimiento',label:'Movimiento'},
                {key:'cantidad',label:'Cantidad'},
                {key:'precioVentaUnitario',label:'Precio Unit.'},
                {key:'precioVentatotal',label:'Total Ingresos'},
                // {key:'stock',label:'Stock'},
                {key:'fechaMovimiento',label:'Fecha Movimiento'}
            ],
            infoitemsalidas:[],
            fields_infoitemsalidas:[
                {key:'descripcionMovimiento',label:'Movimiento'},
                {key:'cantidad',label:'Cantidad'},
                {key:'precioVentaUnitario',label:'Precio Unit.'},
                {key:'precioVentatotal',label:'Total Ingresos'},
                // {key:'stock',label:'Stock'},
                {key:'fechaMovimiento',label:'Fecha Movimiento'}
            ],
            nameitem:'',
            coditem:'',
            cambiofiltro:true,
            filtroitem: 1,
            options: [
                { value: 1, text: "Descripción" },
                { value: 2, text: "Codigo" }
            ],
            nombreitem:true,
            codigoitem:true,
            listaDescription: [],
            listades: false,
            infoItem2:'',

        }
    },
   mounted(){
       this.InitDate()
   },
   watch:{
       filtroitem(){
           if(this.filtroitem == 1){
               this.cambiofiltro = true,
               this.coditem = ''
           }else{
               this.cambiofiltro = false,
               this.nameitem = ''
           }
       },
       nameitem(){
            if(this.nameitem.length > 2){
                this.nombreitem = false
            }else if(this.nameitem.length < 3){
                 this.nombreitem = true               
            }
        },
        coditem(){
            if(this.coditem.length > 2){
                this.codigoitem = false
            }else if(this.coditem.length < 3){
                  this.codigoitem = true
            }
        }
   },
   methods:{
    ListadoKardex(){
        this.cargandoLista = true
        axios
        .post(process.env.VUE_APP_API_URL + "kardex/listarangofecha", {
            token:  this.$store.getters.userToken,
            order:  this.order,
            limit:  this.limit,
            page: this.currentPage,
            f1: this.f1,
            f2: this.f2
        })
        .then(response =>(
            this.mercaderia = response.data.data,
            this.total = response.data.total,
            this.desde = response.data.from,
            this.hasta = response.data.to,
            this.cargandoLista = false
        ))
        .catch(error=>(
            this.$snotify.error(error.response.data, 'Error')
        ))
       },
    InitDate(){
            this.currentdate = this.$moment().format("YYYY-MM-DD  HH:mm:ss");
            this.f1 = this.$moment().format("YYYY-MM-DD  00:00:00");
            this.f2 = this.$moment().format("YYYY-MM-DD  23:59:59"); 
            this.fItem1 = this.$moment().format("YYYY-MM-DD  00:00:00");
            this.fItem2 = this.$moment().format("YYYY-MM-DD  23:59:59");
            this.descriProducto = '';
            this.ListadoKardex()
       },
    customFormatter: function(date) {
        return this.$moment(date).format("YYYY-MM-DD HH:mm:ss");
        },
    ProductSearch(){
         this.cargandoLista = true
        axios
        .post(process.env.VUE_APP_API_URL + "kardex/listarxdescripcion",{
            token: this.$store.getters.userToken,
            search: this.descriProducto,
            f1: this.f1,
            f2: this.f2
        })
        .then(response=>(
            this.mercaderia = response.data.data,
            this.cargandoLista = false
        ))
        .catch(response=>(
            this.$snotify.error(error.response.data.response.message, "Error")
        ))

        },
    kardexitem(){
        let sendfilter=[
        {
            type:40,
            name:"TIPOMOVIMIENTO",
            value:2
        },
        {
            type:41,
            name:"DESCRIPCION",
            value:this.nameitem
        },
        {
            type:42,
            name:"CODIGO",
            value:this.coditem
        },
        ]
        axios
        .post(process.env.VUE_APP_API_URL + "kardex/reporte",{
            token: this.$store.getters.userToken,
            q:  sendfilter,
            f1: this.fItem1,
            f2: this.fItem2,
            order:  this.order2,
            limit:  this.limit2,
            page:   this.currentPage2,
        })
        .then(response=>(
            this.infoitem = response.data.report.data,
            this.total2 = response.data.report.total,
            this.desde2 = response.data.report.from,
            this.hasta2 = response.data.report.to,
            this.kardexitemsalidas(),
            this.infoItem2 = response.data.report.data
        ))
        .catch(response=>(
            this.$snotify.error(error.response.data.response.message, "Error")
        ))
        },
    kardexitemsalidas(){
        let sendfilters=[
        {
            type:40,
            name:"TIPOMOVIMIENTO",
            value:1
        },
        {
            type:41,
            name:"DESCRIPCION",
            value:this.nameitem
        },
        {
            type:42,
            name:"CODIGO",
            value:this.coditem
        },
        ]
        axios
        .post(process.env.VUE_APP_API_URL + "kardex/reporte",{
            token: this.$store.getters.userToken,
            q:  sendfilters,
            f1: this.fItem1,
            f2: this.fItem2,
            order:  this.order3,
            limit:  this.limit3,
            page:   this.currentPage3,
        })
        .then(response=>(
            this.infoitemsalidas = response.data.report.data,
            this.total3 = response.data.report.total,
            this.desde3 = response.data.report.from,
            this.hasta3 = response.data.report.to,
            this.infoItem(response.data.report.data)
        ))
        .catch(response=>(
            this.$snotify.error(error.response.data.response.message, "Error")
        ))
        },
    infoItem(value){
            if(this.infoItem2.length == 0 && value.length == 0){
                this.$snotify.warning("No se encontraron registros", "Ups!")  
            }
        }, 
    descriptionitem(){
        this.listaDescription = [];
        this.listades = true
        axios
        .post(process.env.VUE_APP_API_URL + "productos/buscar",{
            token: this.$store.getters.userToken,
            filtro: "name",
            p: this.nameitem
        })
        .then(response=>(
            this.listaDescription = response.data.response
        ))
        .catch(error=>(
            console.log(error.response.data)
        ))
        },
    obteneritem(value){
        this.nameitem = value.descripcion
        this.listades = false
        this.listaDescription = []
        },
    exportarkardex(){
        let date1 = this.$moment(this.f1).startOf('day').format('YYYY-MM-DD HH:mm:ss');
        let date2 = this.$moment(this.f2).endOf('day').format('YYYY-MM-DD HH:mm:ss');
        let file = '';
        let tag = document.createElement('i');
        tag.classList.add('fa','fa-spin', 'fa-spinner');
        let name = 'Kardex' + ' ' + date1 + '-' + date2 + '.xlsx';
        this.$swal({
            title: 'Procesando Reporte',
            content: tag,
            icon: 'info',
            buttons: false,
            dangerMode: false
        });
        axios
        .post(process.env.VUE_APP_API_URL + 'kardex/excel/rangofechas',{
            token: this.$store.getters.userToken,
            q:[],             
            f1: date1,
            f2: date2,
            // filtro: 0
        })
        .then(response=>{ 
            file = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'+ response.data.base64;
            download(file, name,'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            this.$swal.close()
        })
        .catch(error => { 
            console.log('ingreso error',error)
        })     
        },      
   }
}
</script>
<style scoped>
.contenedor{
    text-align:left;
    }
.searcher-field {
    z-index: 1000;
    position: absolute;
    max-height: 400px !important;
    overflow-y: scroll;
    width: 400px;
    }
.searcher-result {
    text-align: left;
    font-size: smaller;
    padding: 2px 0px 2px 0px;
    cursor: pointer;
    }
</style>